import { render, staticRenderFns } from "./CorporateOptions.vue?vue&type=template&id=92b6efd2"
import script from "./CorporateOptions.vue?vue&type=script&lang=js"
export * from "./CorporateOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports